/**
* Component: gridReducer.js
* Description: This reducer is used for to check the values in edit page or asset view page
*/

//To Set the initial state for the grid reducer
const initialState = {
      selectedGridData:{
        values:{},
        isEdit:false,
        isView:false
      }
};

const gridReducer = (state = initialState, action) => {
  switch (action.type) {
    case "GRID_DATA":
      return {
        ...state,
        selectedGridData : action.payload,
      };
    default:
      return state;
  }
};

export default gridReducer;
